import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges, OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {
    Chart,
    ChartConfiguration,
    ChartData,
    ChartDataset,
    LegendOptions,
    ChartOptions,
    registerables,
    ChartType
} from 'chart.js';
import {Subject} from "rxjs";
import zoomPlugin from 'chartjs-plugin-zoom';
import {arrayIsSet, deepClone, isNotNullOrUndefined} from "../../../providers/service/global-variables.service";

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnChanges, OnDestroy {
    @Input() type: ChartType | undefined;
    @Input() data: ChartData | undefined
    @Input() options: ChartOptions | undefined;
    @Input() plugins: any;
    @Input() isDialogComponent = false;
    @Input() maxDensityBarInChart: number = 1;
    @Input() disabledDatasetsIndex: number[] | undefined;
    @Input() activeIndex: {
        datasetIndex: 0,
        index: 100,
    }[] | undefined
    @Output() chartReady = new Subject<Chart>();


    @ViewChild('Chart', {static: true}) private chartRef: ElementRef<any> | undefined;
    private chart: any | undefined;

    constructor() {
        Chart.register(...registerables, zoomPlugin);

    }


    ngOnChanges(changes: SimpleChanges) {
        let changed = false;
        Object.keys(changes)
            .filter(key => key != 'disabledDatasetsIndex')
            .forEach(el => {
                if (!changes[el].firstChange) {
                    changed = true;
                    (this.chart as any)[el] = changes[el].currentValue;
                }
            });

        const getData = (data: any) => {
            const dataCopy = deepClone(data)
            if (dataCopy && arrayIsSet(dataCopy.datasets)) {
                if (arrayIsSet(this.disabledDatasetsIndex)) {
                    this.disabledDatasetsIndex.forEach(index => {
                        if (dataCopy.datasets[index] != null) {
                            dataCopy.datasets[index].hidden = !dataCopy.datasets[index].hidden
                        }
                    })
                }
            }
            return dataCopy
        }
        if ('disabledDatasetsIndex' in changes) {
            if (this.chart) {
                this.chart.data = getData(this.data)
                this.chart.update()
            }
        }
        if (changed || this.chart == null || (changes.type != null && changes.type.previousValue != changes.type.currentValue)|| (changes.data != null && changes.data.previousValue != changes.data.currentValue)) {
            let {type, data, options, plugins} = this;
            options = {...options}
            const config = {
                type,
                data: data,
                options,
                plugins,
            } as any;
            if (this.chart) {
                this.chart.destroy()
            }
            if (this.chartRef && this.chartRef.nativeElement && config) {
                this.chart = new Chart(this.chartRef?.nativeElement, config);
                this.zoomModify();
                this.chartReady.next(this.chart);
            }
        } else if (this.chart) {
            this.chart.update()
        }
        if ('activeIndex' in changes) {
            if (this.chart && this.chart.tooltip && this.chart.tooltip.setActiveElements) {
                if (this.activeIndex) {
                    this.chart.tooltip.setActiveElements(this.activeIndex)
                } else {
                    this.chart.tooltip.setActiveElements([])
                }
                setTimeout(() => {
                    this.chart.update()
                }, 0)
            }
        }
    }

    ngOnDestroy() {
        this.chart?.destroy()
    }

    private enableDisableDataLabels() {
        if (isNotNullOrUndefined(this.maxDensityBarInChart)) {
            if (this.chart != null && this.chart.options != null && this.chart.options.plugins != null && this.chart.options.plugins.datalabels != null) {
                const width: number = this.chart.width!;
                const numberLabels: number = this.chart?.data?.labels?.length !== 0 ? this.chart?.data?.labels?.length! : 1;
                if ((width / numberLabels) < this.maxDensityBarInChart) {
                    this.chart.options.plugins.datalabels.display = false;
                    this.chart?.update()
                } else {
                    this.chart.options.plugins.datalabels.display = true;
                    this.chart?.update()
                }

            }
        }
    }

    ngAfterViewInit(): void {
        this.enableDisableDataLabels();
    }

    zoomModify() {
        if (this.chart && this.chart.options != null) {
            if ('scales' in this.chart && 'x' in this.chart.scales && 'y' in this.chart.scales) {
                const xMax = (this.chart as any)['scales']['x'].max;
                const xMin = (this.chart as any)['scales']['x'].min;
                const yMax = (this.chart as any)['scales']['y'].max;
                const yMin = (this.chart as any)['scales']['y'].min;
                if ((this.chart as any).options['pan']) {
                    (this.chart as any).options['pan'].rangeMax.x = xMax;
                    (this.chart as any).options['pan'].rangeMin.x = xMin;
                    (this.chart as any).options['pan'].rangeMax.y = yMax;
                    (this.chart as any).options['pan'].rangeMin.y = yMin;
                    (this.chart as any).options['zoom'].rangeMax.x = xMax;
                    (this.chart as any).options['zoom'].rangeMin.x = xMin;
                    (this.chart as any).options['zoom'].rangeMax.y = yMax;
                    (this.chart as any).options['zoom'].rangeMin.y = yMin;
                }
            }

        }
    }


}
